



























import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        InputNumber: InputNumber,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "transaction.certificates.carbonEmission",
            inputName: "epc-co2-emission",
            specificId: uuidv4() as string
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE","OFFICE","INDUSTRY","COMMERCIAL","APARTMENT","GARAGE","OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        co2Emission: function(): string|null {
            const co2 = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if(co2) {
                return co2;
            }
            return "";
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(co2Emission: number): void {
            if (co2Emission == 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": co2Emission});
            }
        },
    },
});
